import { useLocation } from "react-router-dom";

import { AppBar, AppBarProps, Box, Container } from "@mui/material";

import { Player } from "@/components/player";
import { useIsExternalPage } from "@/hooks/useIsExternalPage";
import { useAuth } from "@/providers";
import { AppRoutes } from "@/routes";

import { Navigation } from "./Navigation";

export interface FeetProps extends AppBarProps {
  suppressNavElements?: boolean;
}
export const Feet: React.FC<FeetProps> = ({
  suppressNavElements,
  ...props
}) => {
  const { pathname } = useLocation();

  const { user } = useAuth();
  const isExternalPage = useIsExternalPage();

  const isHomePage = pathname === AppRoutes.ROOT();

  if (!user && isExternalPage) return null;

  return (
    <AppBar
      color="transparent"
      component="footer"
      elevation={0}
      position="fixed"
      sx={(theme) => ({
        bottom: 0,
        displayPrint: "none",
        paddingBottom: `calc(env(safe-area-inset-bottom) + ${theme.spacing(1)})`,
        top: "auto",
        [theme.breakpoints.up("md")]: {
          paddingBottom: `calc(env(safe-area-inset-bottom) + ${theme.spacing(2)})`,
        },
      })}
      {...props}
    >
      {isExternalPage && !user ? null : (
        <Box
          sx={(theme) => ({
            bottom: "100%",
            left: 0,
            mb: user ? 1 : 2,
            position: "absolute",
            right: 0,
            [theme.breakpoints.up("md")]: {
              mb: user ? 2 : 4,
            },
          })}
        >
          <Container maxWidth="xs" fixed>
            <Player suppressNavElements={suppressNavElements} />
          </Container>
        </Box>
      )}
      {!suppressNavElements && user && !isHomePage && (
        <Container maxWidth="xs" fixed>
          <Navigation />
        </Container>
      )}
    </AppBar>
  );
};
